export default "__VITE_ASSET__DtMP9u4u__"